<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-5">
<h1>3</h1>
<p style="text-indent: 0em">Mornings of despair end with nights of agony</p>
<p style="text-indent: 0em">But they lighten my sorrow with their beams of hope</p>
<p style="text-indent: 0em">Friends of mine</p>
<p style="text-indent: 0em">Thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?eba85878